import React, { useState, useReducer } from "react";
import GameType from "../data/GameType";
import { useLocation, useMatches, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Bingo from "../components/bingo/Bingo";
import Game from "../components/Game";
import localDao from "../data/localDao";
import CreateSlipFooter from "../components/CreateSlipFooter";
import QRCode from "react-qr-code";
import NumbersUtil from "../util/NumbersUtil";
import cashier from "../icons/cashier.png";
import Modal from "../components/Modal";

export const EditBetSlip = (props) => {
  const { t } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  const navigate = useNavigate();
  const [gameOrder] = useState([
    GameType.EURO,
    GameType.VIKING,
    GameType.KENO,
    GameType.BINGO,
  ]);
  const [showModal, setShowModal] = useState(false);

  window.scrollTo(0, 0);
  const calculatePrice = () => {
    var cart = localDao.getCart();
    var sum = 0;
    Object.entries(cart).forEach((entry) => {
      var game = entry[1];
      var rows = game.rows;
      sum += game.stake * rows.length * game.drawCount;
    });
    sum = sum / 100;
    return NumbersUtil.padPrice(sum);
  };
  const getNumTicketsText = () => {
    var cart = localDao.getCart();
    var numTickets = 0;
    Object.entries(cart).forEach((entry) => {
      numTickets += entry[1].rows?.length > 0 ? 1 : 0;
    });
    var textKey =
      numTickets === 0 || numTickets > 1 ? "texts.tickets" : "texts.ticket";
    return numTickets + " " + t(textKey);
  };
  const hasAnyRows = () => {
    var cart = localDao.getCart();
    return Object.entries(cart).length > 0;
  };
  const canShowHeaderAndFooter = () => {
    return !props.isFinal;
  };
  const createQR = () => {
    var str = NumbersUtil.getQRString(localDao.getCart());
    return (
      <QRCode
        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        value={str}
      ></QRCode>
    );
  };
  var getGameOrder = (cart) => {
    var renderOrder = [...gameOrder];
    renderOrder.sort((a, b) => {
      var gameA = cart[a.name];
      var gameB = cart[b.name];
      if (gameA?.rows && !gameB?.rows) {
        return -1;
      }
      if (gameB?.rows && !gameA?.rows) {
        return 1;
      }
      if (gameA?.rows && gameB?.rows) {
        return gameA.updatedAt > gameB.updatedAt ? -1 : 1;
      }
      return 0;
    });
    renderOrder = renderOrder.filter((game) => {
      if (props.isFinal) {
        return cart[game.name]?.rows?.length > 0 ? true : false;
      }
      return true;
    });
    return renderOrder;
  };
  const showAddGameAfterCurrent = (cart, game, renderOrder, i) => {
    if (i === 3) {
      //if it's the last game, never show add game text
      return false;
    }
    if (props.isFinal) {
      return false;
    }
    var nextGame = cart[renderOrder[i + 1]?.name];
    if (game?.rows.length > 0 && (!nextGame || nextGame.rows.length < 1)) {
      return true;
    } else {
      return false;
    }
  };

  const showChooseGameBeforeGames= (cart, game, renderOrder, i) => {
    if (i === 3) {
      //if it's the last game, never show add game text
      return false;
    }
    if (props.isFinal) {
      return false;
    }
    var nextGame = cart[renderOrder[i + 1]?.name];
    if ( i === 0 && Object.keys(cart).length < 1 ) {
      return true;
    } else {
      return false;
    }
  };


  const createGames = () => {
    var cart = localDao.getCart();
    var renderOrder = getGameOrder(cart);
    return renderOrder.map((gameType, i) => {
      var addGameText, addGameText2;
      var game = cart[gameType.name];
      if (showAddGameAfterCurrent(cart, game, renderOrder, i)) {
        addGameText = (
          <div key={i} className="bold marginLeft1 marginTop2  fs125 darkBlueText">
            {t("texts.addGame")}
          </div>
        );
      }
      if (showChooseGameBeforeGames(cart, game, renderOrder, i)) {
        addGameText2 = (
          <div key={i} className="bold marginLeft1 marginTop1 fs125 darkBlueText">
          Vali mäng
          </div>
        );
      }
      var gameElement;
      if (gameType === GameType.BINGO) {
        gameElement = (
          <Bingo
            isFinal={props.isFinal}
            key={gameType.name}
            game={game}
            onDeleteGame={forceUpdate}
          ></Bingo>
        );
      } else {
        gameElement = (
          <Game
            onDeleteGame={forceUpdate}
            isOpen={false}
            position={i}
            key={gameType.name}
            game={game}
            gameType={gameType}
            isExpanded={false}
            isFinal={props.isFinal}
            compactOnly={true}
          ></Game>
        );
      }
      return (
        <>
                  {addGameText2 && addGameText2}

          {gameElement}
          {addGameText && addGameText}
        </>
      );
    });
  };


  return (
    <div className={"betSlip " + (props.isFinal ? "marginBottom1" : "")}>
      {/*
      props.isFinal && (
        <div className="lightBlueBg padding1">
          <div>{t("texts.slipCreated")}</div>
        </div>
      )*/
      }
       {props.isFinal && (
        <>
          <div className="showToCashier padding1">
          <div>
            {t("texts.showToClerk")} </div>
          </div>
          <div className="qr flexCenter marginTop1">{createQR()}</div>
        </>
      )}
      <div>{createGames()}
      {!props.isFinal && (
        <>
      <span className="link" onClick={() => setShowModal(true)}>Kuidas kasutada digilipikut?</span>
        </>)}
        {props.isFinal && (
          <span className="link" onClick={() => navigate(process.env.PUBLIC_URL + '/')}>Tagasi Avalehele</span>
        )}
        {!props.isFinal && (
          <a className="link" href="https://www.eestiloto.ee/">eestiloto.ee</a>
        )}
      </div>

      {canShowHeaderAndFooter() && (
        <CreateSlipFooter hasAnyRows={hasAnyRows()} calculatePrice={calculatePrice}></CreateSlipFooter>
      )}
     
{showModal && (
  <Modal showModal={setShowModal}>adasd</Modal>
)}

    </div>
  );
};

export default EditBetSlip;
